export function createSVGIcon(
  name: string,
  count1: number | string,
  count2: number | string,
  strokeColor = "#00FFB4",
  fillColor = "#050f3d",
  width = 200,
  height = 59,
  title1 = "客流评分",
  title2 = "绩效分",
  x1 = 63.358,
) {
  const title = (name?.slice(0)?.length > 14 ? name?.slice(0, 14) + "..." : name?.slice(0)) || ""

  return `
      <svg
      width="${width}"
      height="${height}"
      viewBox="0 0 200 59"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path
          d="M194 .5c1.519 0 2.894.616 3.89 1.61A5.483 5.483 0 0 1 199.5 6v40a5.483 5.483 0 0 1-1.61 3.89A5.483 5.483 0 0 1 194 51.5h-90.481L97 58.02l-6.52-6.52H6a5.483 5.483 0 0 1-3.89-1.61A5.483 5.483 0 0 1 .5 46V6c0-1.519.616-2.894 1.61-3.89A5.483 5.483 0 0 1 6 .5Z"
          fill="${fillColor}"
          fill-opacity=".9"
          stroke="${strokeColor}"
        />
        <text
          font-family="PingFangSC-Regular, PingFang SC"
          font-size="12"
          fill="${strokeColor}"
        >
          <tspan x="11" y="21">
            ${title}
          </tspan>
        </text>
        <text
          font-family="PingFangSC-Regular, PingFang SC"
          font-size="11"
          fill="${strokeColor}"
        >
          <tspan x="11.366" y="39">
            ${title1}
          </tspan>
          <tspan x="55.366" y="39" font-size="12">
            ${" "}
          </tspan>
          <tspan
            x="${x1}"
            y="39"
            font-family="PingFangSC-Medium, PingFang SC"
            font-size="12"
            font-weight="400"
          >
            ${count1}
          </tspan>
        </text>
        <text
          font-family="PingFangSC-Regular, PingFang SC"
          font-size="11"
          fill="${strokeColor}"
        >
          <tspan x="109" y="39">
            ${title2}
          </tspan>
          <tspan x="142" y="39" font-size="12">
            ${" "}
          </tspan>
          <tspan
            x="149.992"
            y="39"
            font-family="PingFangSC-Medium, PingFang SC"
            font-size="12"
            font-weight="400"
          >
            ${count2}
          </tspan>
        </text>
      </g>
    </svg>
  `
}

export function svgToDataURL(svg: string) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
